export default {
  option: {
    edit: "Modifier",
    download: "Télécharger",
    preview: "Aperçu",
    delete: "Supprimer",
    uploaded: "Ajouté",
    "not-uploaded": "À ajouter",
    upload: "Ajouter",
    remove: "Retirer",
  },
}
